var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"method":_vm.method,"action":_vm.action,"accept-charset":"UTF-8"},on:{"submit":_vm.submit}},[_vm._t("default"),_vm._v(" "),_c('spinner-lock',{attrs:{"is-locked":_vm.isLocked}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }